import { render, staticRenderFns } from "./SourcesList.vue?vue&type=template&id=6b64f13d&scoped=true&"
import script from "./SourcesList.vue?vue&type=script&lang=js&"
export * from "./SourcesList.vue?vue&type=script&lang=js&"
import style0 from "./SourcesList.vue?vue&type=style&index=0&id=6b64f13d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b64f13d",
  null
  
)

export default component.exports